import React from "react";

export const ZoomGlassIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ? props.size : "12"}
      viewBox="0 0 23.128 23.134"
    >
      <path
        d="M27.357 25.953l-6.433-6.493a9.167 9.167 0 1 0-1.391 1.409l6.39 6.451a.99.99 0 0 0 1.4.036 1 1 0 0 0 .034-1.403zm-13.636-5.005a7.238 7.238 0 1 1 5.119-2.12 7.194 7.194 0 0 1-5.119 2.12z"
        transform="translate(-4.5 -4.493)"
      />
    </svg>
  );
};

export const BackIcon = (props) => {
  return (
    <svg
      className={props.className}
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ? props.size : 24}
      style={props.style}
      viewBox="0 0 24.935 16.624"
    >
      <path
        d="M29.435 15.926H9.806l4.959-4.973L12.812 9 4.5 17.312l8.312 8.312 1.953-1.953L9.806 18.7h19.63z"
        transform="translate(-4.5 -9)"
      />
    </svg>
  );
};

export const ZoomInIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4414 8.65234H10.1367V6.03516C10.1367 5.94922 10.0664 5.87891 9.98047 5.87891H8.80859C8.72266 5.87891 8.65234 5.94922 8.65234 6.03516V8.65234H6.34766C6.26172 8.65234 6.19141 8.72266 6.19141 8.80859V9.98047C6.19141 10.0664 6.26172 10.1367 6.34766 10.1367H8.65234V12.7539C8.65234 12.8398 8.72266 12.9102 8.80859 12.9102H9.98047C10.0664 12.9102 10.1367 12.8398 10.1367 12.7539V10.1367H12.4414C12.5273 10.1367 12.5977 10.0664 12.5977 9.98047V8.80859C12.5977 8.72266 12.5273 8.65234 12.4414 8.65234ZM17.9883 16.9336L15.1367 14.082C17.5215 11.1738 17.3555 6.86523 14.6289 4.14063C11.7383 1.24805 7.04297 1.24805 4.14063 4.14063C1.24805 7.04297 1.24805 11.7383 4.14063 14.6289C6.86523 17.3555 11.1738 17.5215 14.082 15.1367L16.9336 17.9883C16.9961 18.043 17.0957 18.043 17.1484 17.9883L17.9883 17.1484C18.043 17.0957 18.043 16.9961 17.9883 16.9336ZM13.5938 13.5938C11.2734 15.9121 7.51563 15.9121 5.19531 13.5938C2.87695 11.2734 2.87695 7.51563 5.19531 5.19531C7.51563 2.87695 11.2734 2.87695 13.5938 5.19531C15.9121 7.51563 15.9121 11.2734 13.5938 13.5938Z"
        fill="white"
      />
    </svg>
  );
};

export const ZoomOutIcon = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4414 8.65234H6.34766C6.26172 8.65234 6.19141 8.72266 6.19141 8.80859V9.98047C6.19141 10.0664 6.26172 10.1367 6.34766 10.1367H12.4414C12.5273 10.1367 12.5977 10.0664 12.5977 9.98047V8.80859C12.5977 8.72266 12.5273 8.65234 12.4414 8.65234ZM17.9883 16.9336L15.1367 14.082C17.5215 11.1738 17.3555 6.86523 14.6289 4.14063C11.7383 1.24805 7.04297 1.24805 4.14063 4.14063C1.24805 7.04297 1.24805 11.7383 4.14063 14.6289C6.86523 17.3555 11.1738 17.5215 14.082 15.1367L16.9336 17.9883C16.9961 18.043 17.0957 18.043 17.1484 17.9883L17.9883 17.1484C18.043 17.0957 18.043 16.9961 17.9883 16.9336ZM13.5938 13.5938C11.2734 15.9121 7.51563 15.9121 5.19531 13.5938C2.87695 11.2734 2.87695 7.51563 5.19531 5.19531C7.51563 2.87695 11.2734 2.87695 13.5938 5.19531C15.9121 7.51563 15.9121 11.2734 13.5938 13.5938Z"
        fill="white"
      />
    </svg>
  );
};

export const SendIcon = (props) => {
  return (
    <span style={{ marginRight: props.mr ? props.mr : "5px" }}>
      <svg
        className={props.className}
        width={props.size ? props.size : 24}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 17.079 17.077"
      >
        <path
          id="Icon_ionic-ios-send"
          fill="#fff"
          d="M21.043 4.541L4.714 11.658a.374.374 0 0 0 .013.681l4.417 2.5a.712.712 0 0 0 .814-.08l8.709-7.508c.058-.049.2-.142.249-.089s-.031.191-.08.249L11.3 15.892a.71.71 0 0 0-.071.85l2.887 4.63a.376.376 0 0 0 .676-.009l6.754-16.328a.374.374 0 0 0-.503-.494z"
          data-name="Icon ionic-ios-send"
          transform="translate(-4.503 -4.503)"
        />
      </svg>
    </span>
  );
};

export const CheckIcon = (props) => {
  return (
    <>
      <svg
        className={props.className}
        xmlns="http://www.w3.org/2000/svg"
        width={props.size ? props.size : 14}
        style={{ marginRight: props.mr ? props.mr : "5px" }}
        viewBox="0 0 20.416 14.74"
      >
        <path
          id="Icon_feather-check"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="3px"
          d="M22.173 9L11.054 20.119 6 15.065"
          data-name="Icon feather-check"
          transform="translate(-3.879 -6.879)"
        />
      </svg>
    </>
  );
};

export const FolderIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ? props.size : "12"}
      style={{ margin: "0 0.3rem" }}
      viewBox="0 0 32.479 28.71"
    >
      <g id="_001-folder" transform="translate(0 -.164)">
        <path
          id="Path_442"
          d="M59.837 76.334H47.873a3.128 3.128 0 0 0-3.128 3.128v16.246a3.913 3.913 0 0 1-3.156.338l.027-.084v-19a3.128 3.128 0 0 1 3.128-3.128h12.591a2.5 2.5 0 0 1 2.502 2.5zm0 0"
          fill="#6fe3ff"
          transform="translate(-38.338 -67.907)"
        />
        <path
          id="Path_443"
          fill="#e48e66"
          d="M58.878 154.088a3.9 3.9 0 0 0 1.841-2.477l3.41-12.039a3.129 3.129 0 0 1 3.044-2.407h14.1a3.128 3.128 0 0 1 3.069 3.734l-2.674 11.193a3.128 3.128 0 0 1-3.069 2.522H56.922a3.9 3.9 0 0 0 1.956-.526zm0 0"
          transform="translate(-52.471 -126.286)"
        />
        <path
          id="Path_444"
          fill="#f8ec7d"
          d="M32.644 13.526v3.8H31.08a2.45 2.45 0 0 0-2.449-2.45h-.679a2.5 2.5 0 0 0-2.5-2.5H12.86a3.128 3.128 0 0 0-3.128 3.128v19l-.027.084A3.906 3.906 0 0 1 7 30.875v-20.39a3.32 3.32 0 0 1 3.32-3.32h7.742a3.127 3.127 0 0 1 2.053.769l1.729 1.5a3.126 3.126 0 0 0 2.054.769h5.426a3.32 3.32 0 0 1 3.32 3.323zm0 0"
          transform="translate(-6.453 -6.453)"
        />
        <path
          id="Path_445"
          d="M100.161 108.282h-9.925a3.129 3.129 0 0 0-3.044 2.407l-3.41 12.039a3.9 3.9 0 0 1-1.841 2.477V108.96a3.128 3.128 0 0 1 3.128-3.128h12.643a2.45 2.45 0 0 1 2.449 2.45zm0 0"
          fill="#6fe3ff"
          transform="translate(-75.534 -97.405)"
        />
        <path
          id="Path_446"
          fill="#63316d"
          d="M28.8 10.33h-2.061V7.074a3.872 3.872 0 0 0-3.867-3.868h-5.426a2.579 2.579 0 0 1-1.694-.634l-1.729-1.5a3.674 3.674 0 0 0-2.413-.9H3.868A3.872 3.872 0 0 0 0 4.032v20.391a4.447 4.447 0 0 0 4.217 4.445v.006h21.912a3.683 3.683 0 0 0 3.6-2.952L32.4 14.739v-.021a3.675 3.675 0 0 0-3.6-4.388zM1.095 24.423V4.032a2.776 2.776 0 0 1 2.773-2.773h7.742a2.58 2.58 0 0 1 1.694.634l1.729 1.5a3.673 3.673 0 0 0 2.413.9h5.426a2.776 2.776 0 0 1 2.772 2.773v3.264h-.52a3 3 0 0 0-2.946-2.45H22a3.055 3.055 0 0 0-3-2.5H6.408a3.68 3.68 0 0 0-3.676 3.673v18.252a3.377 3.377 0 0 1-.655-.509 3.339 3.339 0 0 1-.982-2.373zM22.178 8.975A1.905 1.905 0 0 1 24 10.33h-9.3a3.663 3.663 0 0 0-3.573 2.816L7.723 25.174l-.006.023a3.366 3.366 0 0 1-.762 1.457v-15.1a2.584 2.584 0 0 1 2.581-2.579zM3.827 27.721V9.053a2.584 2.584 0 0 1 2.581-2.581H19a1.959 1.959 0 0 1 1.874 1.408H9.536a3.68 3.68 0 0 0-3.676 3.675v15.912a3.349 3.349 0 0 1-2.033.254zM31.337 14.5l-2.672 11.177v.021a2.586 2.586 0 0 1-2.532 2.081H7.373a4.474 4.474 0 0 0 1.407-2.317l3.406-12.028.006-.023a2.572 2.572 0 0 1 2.508-1.986h14.1a2.58 2.58 0 0 1 2.537 3.075zm0 0"
        />
      </g>
    </svg>
  );
};

export const RightIcon = (props) => {
  return (
    <svg
      width={props.size ? props.size : "12"}
      style={{ margin: "0 0.3rem" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 29.038 29.019"
    >
      <g id="check" transform="translate(0 -.168)">
        <ellipse
          id="Ellipse_54"
          cx="14.519"
          cy="14.509"
          fill="#32bea6"
          data-name="Ellipse 54"
          rx="14.519"
          ry="14.509"
          transform="translate(0 .168)"
        />
        <path
          id="Path_293"
          fill="#fff"
          d="M121.3 149.112l-6.865-5.348 1.952-2.5 4.215 3.284 6.957-10.039 2.611 1.809z"
          data-name="Path 293"
          transform="translate(-107.942 -126.717)"
        />
      </g>
    </svg>
  );
};

export const RightIconPDF = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M4 13H6L11 8L6 3H4L9 8L4 13Z" fill="white" />
    </svg>
  );
};

export const BackIconPDF = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 13H10L5 8L10 3H12L7 8L12 13Z" fill="white" />
    </svg>
  );
};

export const LeftRotatePDF = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.053 6.811L2.30359 6.87755M2.38124 11.2519C2.4367 14.3764 6.0002 18.0637 10.3145 17.9871C12.3862 17.9504 14.3584 17.0921 15.7973 15.6012C17.2362 14.1103 18.0239 12.1089 17.9871 10.0372C17.9504 7.96553 17.0921 5.99331 15.6012 4.55442C14.1103 3.11552 12.1089 2.32782 10.0372 2.36459C5.35046 2.44778 2.30359 6.87755 2.30359 6.87755L2.22595 2.50323"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const RightRotatePDF = () => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.0625 6.5625H17.8125M17.8125 10.9375C17.8125 14.0625 14.315 17.8125 10 17.8125C7.928 17.8125 5.94086 16.9894 4.47573 15.5243C3.0106 14.0591 2.1875 12.072 2.1875 10C2.1875 7.928 3.0106 5.94086 4.47573 4.47573C5.94086 3.0106 7.928 2.1875 10 2.1875C14.6875 2.1875 17.8125 6.5625 17.8125 6.5625V2.1875"
        stroke="white"
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export const MoneyIcon = (props) => {
  return (
    <svg
      width={props.size ? props.size : "12"}
      style={{ margin: "0 0.3rem" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 36.755 29.873"
    >
      <g id="_002-money" data-name="002-money" transform="translate(0 -47.936)">
        <path
          id="Path_317"
          d="M2.239 188.063a221.378 221.378 0 0 1 27.44 0 1.765 1.765 0 0 1 1.636 1.5 53.459 53.459 0 0 1 0 16 1.765 1.765 0 0 1-1.636 1.5 221.378 221.378 0 0 1-27.44 0 1.765 1.765 0 0 1-1.636-1.5 53.459 53.459 0 0 1 0-16 1.765 1.765 0 0 1 1.636-1.5z"
          fill="#78c2a4"
          data-name="Path 317"
          transform="translate(0 -129.672)"
        />
        <path
          id="Path_318"
          d="M31.1 230.626a2.994 2.994 0 0 0-3.347-2.976 51.708 51.708 0 0 1 0-9.119 2.994 2.994 0 0 0 3.347-2.976v-.162c3.478-.165 6.975-.25 10.436-.25 3.342 0 6.719.078 10.079.232 0 .059-.006.119-.006.179a3 3 0 0 0 3.7 2.914 51.7 51.7 0 0 1 0 9.244 3 3 0 0 0-3.7 2.914c0 .06 0 .12.006.179-3.36.154-6.737.232-10.079.232-3.46 0-6.958-.085-10.436-.25v-.161z"
          fill="#b3e59f"
          data-name="Path 318"
          transform="translate(-25.576 -155.203)"
        />
        <ellipse
          id="Ellipse_70"
          cx="4.606"
          cy="6.277"
          fill="#78c2a4"
          data-name="Ellipse 70"
          rx="4.606"
          ry="6.277"
          transform="translate(11.353 61.61)"
        />
        <g
          id="Group_48"
          data-name="Group 48"
          transform="translate(4.784 66.338)"
        >
          <circle
            id="Ellipse_71"
            cx="1.549"
            cy="1.549"
            r="1.549"
            fill="#78c2a4"
            data-name="Ellipse 71"
          />
          <circle
            id="Ellipse_72"
            cx="1.549"
            cy="1.549"
            r="1.549"
            fill="#78c2a4"
            data-name="Ellipse 72"
            transform="translate(19.251)"
          />
        </g>
        <g
          id="Group_50"
          data-name="Group 50"
          transform="translate(4.839 47.936)"
        >
          <path
            id="Path_320"
            d="M69.644 48.362a221.377 221.377 0 0 1 27.44 0 1.765 1.765 0 0 1 1.636 1.5 53.459 53.459 0 0 1 0 16 1.765 1.765 0 0 1-1.636 1.5 221.375 221.375 0 0 1-27.44 0 1.765 1.765 0 0 1-1.636-1.5 53.459 53.459 0 0 1 0-16 1.765 1.765 0 0 1 1.636-1.5z"
            fill="#78c2a4"
            data-name="Path 320"
            transform="translate(-67.405 -47.936)"
          />
          <path
            id="Path_321"
            d="M98.508 90.926a2.994 2.994 0 0 0-3.347-2.976 51.707 51.707 0 0 1 0-9.119 2.994 2.994 0 0 0 3.347-2.977v-.162c3.478-.165 6.975-.25 10.436-.25 3.342 0 6.719.078 10.079.232 0 .059-.006.119-.006.179a3 3 0 0 0 3.7 2.914 51.707 51.707 0 0 1 0 9.244 3 3 0 0 0-3.7 2.914c0 .06 0 .12.006.179-3.36.154-6.737.232-10.079.232-3.46 0-6.958-.085-10.436-.25-.002-.052 0-.105 0-.16z"
            fill="#b3e59f"
            data-name="Path 321"
            transform="translate(-92.981 -73.468)"
          />
          <ellipse
            id="Ellipse_73"
            cx="4.606"
            cy="6.277"
            fill="#78c2a4"
            data-name="Ellipse 73"
            rx="4.606"
            ry="6.277"
            transform="translate(11.353 3.645)"
          />
          <g
            id="Group_49"
            data-name="Group 49"
            transform="translate(4.784 8.373)"
          >
            <circle
              id="Ellipse_74"
              cx="1.549"
              cy="1.549"
              r="1.549"
              fill="#78c2a4"
              data-name="Ellipse 74"
            />
            <circle
              id="Ellipse_75"
              cx="1.549"
              cy="1.549"
              r="1.549"
              fill="#78c2a4"
              data-name="Ellipse 75"
              transform="translate(19.251)"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const PermissionIcon = (props) => {
  return (
    <svg
      width={props.size ? props.size : "12"}
      style={{ margin: "0 0.3rem" }}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 25.731 28.794"
    >
      <g id="_001-file" data-name="001-file" transform="translate(-25.6)">
        <path
          id="Path_304"
          fill="#75e4de"
          d="M48.093 10.24H38.9a3.072 3.072 0 0 0-3.06 3.06v21.445a3.072 3.072 0 0 0 3.06 3.064h9.19"
          data-name="Path 304"
          transform="translate(-9.627 -9.627)"
        />
        <path
          id="Path_305"
          d="M80.476 154.825h-3.063a.613.613 0 0 1 0-1.225h3.063a.613.613 0 1 1 0 1.225z"
          data-name="Path 305"
          transform="translate(-48.137 -144.41)"
        />
        <path
          id="Path_306"
          d="M80.476 206.025h-3.063a.613.613 0 1 1 0-1.225h3.063a.613.613 0 1 1 0 1.225z"
          data-name="Path 306"
          transform="translate(-48.137 -192.547)"
        />
        <path
          id="Path_307"
          d="M80.476 257.225h-3.063a.613.613 0 0 1 0-1.225h3.063a.613.613 0 0 1 0 1.225z"
          data-name="Path 307"
          transform="translate(-48.137 -240.684)"
        />
        <path
          id="Path_308"
          d="M80.476 52.425h-3.063a.613.613 0 1 1 0-1.225h3.063a.613.613 0 1 1 0 1.225z"
          data-name="Path 308"
          transform="translate(-48.137 -48.137)"
        />
        <path
          id="Path_309"
          fill="#f3e804"
          d="M147.43 37.809h-6.13a3.072 3.072 0 0 1-3.063-3.063V13.3a3.072 3.072 0 0 1 3.063-3.06h9.19l6.126 6.126v12.253h-6.126a3.072 3.072 0 0 0-3.063 3.063z"
          data-name="Path 309"
          transform="translate(-105.901 -9.627)"
        />
        <path
          id="Path_310"
          fill="#f6ac0d"
          d="M349.166 16.366H346.1a3.072 3.072 0 0 1-3.06-3.066v-3.06z"
          data-name="Path 310"
          transform="translate(-298.448 -9.627)"
        />
        <path
          id="Path_311"
          d="M51.331 6.616c0-.061-.031-.092-.061-.153a.03.03 0 0 0-.031-.031.423.423 0 0 0-.092-.123L45.021.184C44.99.153 44.929.123 44.9.092a.03.03 0 0 1-.031-.031c-.063-.03-.093-.03-.155-.061H29.276A3.687 3.687 0 0 0 25.6 3.676v21.442a3.687 3.687 0 0 0 3.676 3.676h12.253a.614.614 0 0 0 .613-.613v-6.126a2.458 2.458 0 0 1 2.45-2.455h6.126a.614.614 0 0 0 .613-.613V6.616zM45.2 2.083L47.226 4.1l2.022 2.022h-1.593A2.458 2.458 0 0 1 45.2 3.676zM26.825 25.118V3.676a2.458 2.458 0 0 1 2.451-2.451h3.4a3.645 3.645 0 0 0-.95 2.451v21.442a3.645 3.645 0 0 0 .95 2.451h-3.4a2.458 2.458 0 0 1-2.451-2.451zm17.766-6.739a3.687 3.687 0 0 0-3.676 3.676v5.514H35.4a2.458 2.458 0 0 1-2.451-2.451V3.676A2.458 2.458 0 0 1 35.4 1.225h8.577v2.451a3.687 3.687 0 0 0 3.676 3.676h2.451v11.027z"
          data-name="Path 311"
        />
        <path
          id="Path_312"
          d="M339.539 361.463h-2.451v-2.451a.613.613 0 0 0-1.225 0v2.451h-2.451a.613.613 0 1 0 0 1.225h2.451v2.451a.613.613 0 0 0 1.225 0v-2.451h2.451a.613.613 0 1 0 0-1.225z"
          data-name="Path 312"
          transform="translate(-288.821 -336.958)"
        />
        <path
          id="Path_313"
          d="M192.065 154.825h-12.252a.613.613 0 1 1 0-1.225h12.253a.613.613 0 0 1 0 1.225z"
          data-name="Path 313"
          transform="translate(-144.41 -144.41)"
        />
        <path
          id="Path_314"
          d="M192.065 206.025h-12.252a.613.613 0 1 1 0-1.225h12.253a.613.613 0 1 1 0 1.225z"
          data-name="Path 314"
          transform="translate(-144.41 -192.547)"
        />
        <path
          id="Path_315"
          d="M192.065 257.225h-12.252a.613.613 0 1 1 0-1.225h12.253a.613.613 0 1 1 0 1.225z"
          data-name="Path 315"
          transform="translate(-144.41 -240.684)"
        />
        <path
          id="Path_316"
          d="M185.939 52.425h-6.126a.613.613 0 1 1 0-1.225h6.126a.613.613 0 1 1 0 1.225z"
          data-name="Path 316"
          transform="translate(-144.41 -48.137)"
        />
      </g>
    </svg>
  );
};
export const ArchiveIcon = (props) => {
  return (
    <>
      <svg
        width={props.size ? props.size : "12"}
        style={{ margin: "0 0.3rem" }}
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20.648 26.914"
      >
        <g
          id="prefix___002-archive"
          data-name="002-archive"
          transform="translate(-59.6)"
        >
          <g
            id="prefix__Group_35"
            data-name="Group 35"
            transform="translate(77.145 .394)"
          >
            <path
              id="prefix__Path_253"
              fill="#f1f4f6"
              d="M395.187 33.625h-1.805V7.5h1.805a.9.9 0 0 1 .9.9v24.32a.9.9 0 0 1-.9.905z"
              data-name="Path 253"
              transform="translate(-393.382 -7.5)"
            />
          </g>
          <g
            id="prefix__Group_36"
            data-name="Group 36"
            transform="translate(62.118 .394)"
          >
            <path
              id="prefix__Path_254"
              fill="#ffe07d"
              d="M122.533 33.625h-15.027V7.5h15.027a.9.9 0 0 1 .9.9v24.32a.9.9 0 0 1-.9.905z"
              data-name="Path 254"
              transform="translate(-107.506 -7.5)"
            />
          </g>
          <g
            id="prefix__Group_37"
            data-name="Group 37"
            transform="translate(76.774 .394)"
          >
            <path
              id="prefix__Path_255"
              fill="#ffd064"
              d="M386.311 7.5v26.125h.372a.9.9 0 0 0 .9-.9V8.4a.9.9 0 0 0-.9-.9z"
              data-name="Path 255"
              transform="translate(-386.311 -7.5)"
            />
          </g>
          <g
            id="prefix__Group_38"
            data-name="Group 38"
            transform="translate(65.304 3.58)"
          >
            <path
              id="prefix__Path_256"
              fill="#f6f9f9"
              d="M0 0h5.31v9.558H0z"
              data-name="Path 256"
              transform="rotate(90 4.779 4.779)"
            />
          </g>
          <g
            id="prefix__Group_39"
            data-name="Group 39"
            transform="translate(59.994 .394)"
          >
            <path
              id="prefix__Path_257"
              fill="#ebb044"
              d="M67.1 7.5h2.124v26.125H67.1z"
              data-name="Path 257"
              transform="translate(-67.1 -7.5)"
            />
          </g>
          <g
            id="prefix__Group_40"
            data-name="Group 40"
            transform="translate(78.048 1.881)"
          >
            <path
              id="prefix__Path_258"
              fill="#cbe2ff"
              d="M412.36 40.564l-1.805.531v-5.31l1.805.531z"
              data-name="Path 258"
              transform="translate(-410.555 -35.785)"
            />
          </g>
          <g
            id="prefix__Group_41"
            data-name="Group 41"
            transform="translate(78.048 7.191)"
          >
            <path
              id="prefix__Path_259"
              fill="#e28086"
              d="M412.36 141.58l-1.805.531V136.8l1.805.531z"
              data-name="Path 259"
              transform="translate(-410.555 -136.801)"
            />
          </g>
          <g
            id="prefix__Group_42"
            data-name="Group 42"
            transform="translate(78.048 12.501)"
          >
            <path
              id="prefix__Path_260"
              fill="#9bd069"
              d="M412.36 242.6l-1.805.531v-5.31l1.805.531z"
              data-name="Path 260"
              transform="translate(-410.555 -237.817)"
            />
          </g>
          <g
            id="prefix__Group_43"
            data-name="Group 43"
            transform="translate(59.6)"
          >
            <path
              id="prefix__Path_261"
              d="M78.951 0H59.994a.394.394 0 0 0-.394.394v4.252a.394.394 0 0 0 .788 0V.788h1.335v25.337h-1.335V6.488a.394.394 0 0 0-.788 0v20.031a.394.394 0 0 0 .394.394h18.957a1.3 1.3 0 0 0 1.3-1.3v-3.845a.394.394 0 1 0-.788 0v3.849a.509.509 0 0 1-.508.508h-.612a1.29 1.29 0 0 0 .1-.508v-7.511l1.017-.3v2.119a.394.394 0 1 0 .788 0V1.3a1.3 1.3 0 0 0-1.3-1.3zm.508 11.675l-1.017.3V7.718l1.017.3zm-.014-4.484h.014V7.2zm.014-.826l-1.017.3V2.408l1.017.3zm0 6.132v.008h-.014zm0-11.2v.588l-1.017-.3V1.3a1.289 1.289 0 0 0-.1-.508h.612a.509.509 0 0 1 .505.508zm-2.42 24.828H62.512V.788h14.633a.509.509 0 0 1 .508.508v24.32a.509.509 0 0 1-.508.508h-.106zm1.4-8.841v-4.256l1.017.3v3.658z"
              data-name="Path 261"
              transform="translate(-59.6)"
            />
            <path
              id="prefix__Path_262"
              d="M249.263 94.955h-3.4a.394.394 0 0 0 0 .788h3.4a.394.394 0 1 0 0-.788z"
              data-name="Path 262"
              transform="translate(-235.7 -89.964)"
            />
            <path
              id="prefix__Path_263"
              d="M193.335 95.743h1.065a.394.394 0 0 0 0-.788h-1.062a.394.394 0 0 0 0 .788z"
              data-name="Path 263"
              transform="translate(-185.932 -89.964)"
            />
            <path
              id="prefix__Path_264"
              d="M193.335 128.068h6.16a.394.394 0 1 0 0-.788h-6.16a.394.394 0 0 0 0 .788z"
              data-name="Path 264"
              transform="translate(-185.932 -120.589)"
            />
            <path
              id="prefix__Path_265"
              d="M170.568 60.61h-2.247a.394.394 0 0 0 0 .788h1.853v4.522H161.4V61.4h5.074a.394.394 0 0 0 0-.788h-5.464a.394.394 0 0 0-.394.394v5.31a.394.394 0 0 0 .394.394h9.558a.394.394 0 0 0 .394-.394V61a.394.394 0 0 0-.394-.39z"
              data-name="Path 265"
              transform="translate(-155.306 -57.424)"
            />
            <path
              id="prefix__Path_266"
              d="M164.94 432.35h-3.93a.394.394 0 1 0 0 .788h3.929a.394.394 0 1 0 0-.788z"
              data-name="Path 266"
              transform="translate(-155.306 -409.623)"
            />
            <path
              id="prefix__Path_267"
              d="M162.6 464.675h-1.59a.394.394 0 0 0 0 .789h1.59a.394.394 0 0 0 0-.789z"
              data-name="Path 267"
              transform="translate(-155.306 -440.249)"
            />
            <path
              id="prefix__Path_268"
              d="M164.94 400.024h-3.93a.394.394 0 1 0 0 .788h3.929a.394.394 0 1 0 0-.788z"
              data-name="Path 268"
              transform="translate(-155.306 -378.996)"
            />
          </g>
        </g>
      </svg>
    </>
  );
};

export const DocumentIcon = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={props.size ? props.size : "28"}
      viewBox="0 0 389.479 511.354"
    >
      <g
        id="_001-contract"
        data-name="001-contract"
        transform="translate(0 -0.322)"
      >
        <g id="Group_109" data-name="Group 109">
          <g id="Group_106" data-name="Group 106">
            <g id="Group_100" data-name="Group 100">
              <path
                id="Path_449"
                data-name="Path 449"
                d="M47.478,452.317l295.441,19.76a10,10,0,0,0,10.645-9.31L381.957,38.25a10,10,0,0,0-9.31-10.645L77.206,7.845a10,10,0,0,0-10.645,9.31L38.167,441.672a10,10,0,0,0,9.311,10.645Z"
                fill="#fae19e"
              />
            </g>
            <g id="Group_105" data-name="Group 105">
              <g id="Group_104" data-name="Group 104">
                <g id="Group_103" data-name="Group 103">
                  <g id="Group_102" data-name="Group 102">
                    <g id="Group_101" data-name="Group 101">
                      <path
                        id="Path_450"
                        data-name="Path 450"
                        d="M17.5,504.177H243.64l79.96-79.605V68.712a10,10,0,0,0-10-10H17.5a10,10,0,0,0-10,10V494.178A10,10,0,0,0,17.5,504.177Z"
                        fill="#fff9e9"
                      />
                    </g>
                    <path
                      id="Path_451"
                      data-name="Path 451"
                      d="M313.6,58.712h-40a10,10,0,0,1,10,10V424.573l-.258,40.078L323.6,424.573V68.712a10,10,0,0,0-10-10Z"
                      fill="#fff4d6"
                    />
                  </g>
                </g>
              </g>
              <path
                id="Path_452"
                data-name="Path 452"
                d="M243.64,504.177V433.924a10,10,0,0,1,10-10H323.6Z"
                fill="#ffeec2"
              />
            </g>
          </g>
        </g>
        <g id="Group_110" data-name="Group 110">
          <path
            id="Path_459"
            data-name="Path 459"
            d="M373.147,20.122,77.707.361A17.523,17.523,0,0,0,59.078,16.654L56.767,51.211H17.5A17.521,17.521,0,0,0,0,68.711V494.177a17.521,17.521,0,0,0,17.5,17.5H243.641a7.581,7.581,0,0,0,5.292-2.185l34.138-33.987a7.447,7.447,0,0,0,1.065.157l58.282,3.9a17.936,17.936,0,0,0,18.629-16.293L389.44,38.752a17.651,17.651,0,0,0-16.293-18.63Zm-122.006,465.9v-52.1a2.5,2.5,0,0,1,2.5-2.5h51.9Zm94.939-23.757a2.5,2.5,0,0,1-2.66,2.327l-46.28-3.1,31.752-31.611a7.5,7.5,0,0,0,2.209-5.315V68.712a17.521,17.521,0,0,0-17.5-17.5H235.608c-9.7,0-9.7,15,0,15H313.6a2.5,2.5,0,0,1,2.5,2.5V416.424h-62.46a17.521,17.521,0,0,0-17.5,17.5v62.753H17.5a2.5,2.5,0,0,1-2.5-2.5V68.712a2.5,2.5,0,0,1,2.5-2.5H195.668c9.7,0,9.7-15,0-15H71.8l2.244-33.556a2.5,2.5,0,0,1,2.661-2.327l295.44,19.76a2.5,2.5,0,0,1,2.328,2.661Z"
            fill="#060606"
          />
          <path
            id="Path_460"
            data-name="Path 460"
            d="M267.827,237.047H63.274a7.5,7.5,0,0,0,0,15H267.827a7.5,7.5,0,0,0,0-15Z"
            fill="#060606"
          />
          <path
            id="Path_461"
            data-name="Path 461"
            d="M267.827,289.332H63.274a7.5,7.5,0,0,0,0,15H267.827a7.5,7.5,0,0,0,0-15Z"
            fill="#060606"
          />
          <path
            id="Path_462"
            data-name="Path 462"
            d="M55.774,192.262a7.5,7.5,0,0,0,7.5,7.5H267.827a7.5,7.5,0,0,0,0-15H63.274a7.5,7.5,0,0,0-7.5,7.5Z"
            fill="#060606"
          />
          <path
            id="Path_463"
            data-name="Path 463"
            d="M91.807,139.977a7.5,7.5,0,0,0,7.5,7.5H231.794a7.5,7.5,0,0,0,0-15H99.307a7.5,7.5,0,0,0-7.5,7.5Z"
            fill="#060606"
          />
          <path
            id="Path_464"
            data-name="Path 464"
            d="M194.755,438.787q-20.233.054-40.467.086-6.8.01-13.6.016c-8.215.006-13.75-1.643-15.59-10.679-1.556-7.64-12.364-6.613-14.464,0-5.19,16.337-13.774,9.936-18.582-1.053-4.8-10.963-6.027-23.233-8.122-34.9-1.54-8.573-14.506-6.17-14.732,1.994a139.752,139.752,0,0,1-4.031,31.758c-2.815,10.758-7.034,21.1-11.222,31.376-3.651,8.961,10.867,12.816,14.464,3.988A289.6,289.6,0,0,0,78.6,433.659c5.14,12.36,15.774,26.34,30.927,18.1a30.208,30.208,0,0,0,7.763-6.253c7.88,9.106,19.609,8.388,30.584,8.375q23.44-.03,46.881-.1c9.649-.025,9.667-15.025,0-15Z"
            fill="#060606"
          />
        </g>
      </g>
    </svg>
  );
};

export const Twitter = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.026 15C11.064 15 14.367 9.997 14.367 5.666C14.367 5.526 14.367 5.384 14.361 5.244C15.0041 4.77848 15.5591 4.20215 16 3.542C15.3993 3.80685 14.7628 3.9814 14.111 4.06C14.7975 3.64964 15.3117 3.00397 15.558 2.243C14.913 2.62512 14.207 2.89337 13.471 3.036C12.9762 2.50902 12.3214 2.15992 11.6081 2.04276C10.8948 1.9256 10.1627 2.04692 9.52534 2.38794C8.88796 2.72895 8.38081 3.27063 8.08245 3.92906C7.78409 4.58749 7.71118 5.32593 7.875 6.03C6.56974 5.96455 5.29282 5.62547 4.12704 5.03474C2.96127 4.44402 1.93268 3.61484 1.108 2.601C0.68934 3.32408 0.561574 4.1794 0.750646 4.99326C0.939718 5.80713 1.43145 6.51853 2.126 6.983C1.60554 6.96532 1.09652 6.82556 0.64 6.575V6.62C0.640897 7.37748 0.903307 8.11142 1.38287 8.69776C1.86244 9.2841 2.52975 9.68687 3.272 9.838C2.99026 9.91561 2.69923 9.95431 2.407 9.953C2.20098 9.95362 1.99538 9.93454 1.793 9.896C2.00279 10.5481 2.41127 11.1182 2.96125 11.5265C3.51122 11.9348 4.17513 12.1608 4.86 12.173C3.69656 13.0868 2.2594 13.5824 0.78 13.58C0.519321 13.5811 0.258823 13.5661 0 13.535C1.50151 14.4923 3.2453 15.0005 5.026 15V15Z"
        fill="white"
      />
    </svg>
  );
};

export const Facebook = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.67 4H5.33C4.97807 4.00262 4.6413 4.14358 4.39244 4.39244C4.14358 4.6413 4.00262 4.97807 4 5.33V26.67C4.00262 27.0219 4.14358 27.3587 4.39244 27.6076C4.6413 27.8564 4.97807 27.9974 5.33 28H16.82V18.72H13.7V15.09H16.82V12.42C16.82 9.32 18.71 7.63 21.49 7.63C22.42 7.63 23.35 7.63 24.28 7.77V11H22.37C20.86 11 20.57 11.72 20.57 12.77V15.08H24.17L23.7 18.71H20.57V28H26.67C27.0219 27.9974 27.3587 27.8564 27.6076 27.6076C27.8564 27.3587 27.9974 27.0219 28 26.67V5.33C27.9974 4.97807 27.8564 4.6413 27.6076 4.39244C27.3587 4.14358 27.0219 4.00262 26.67 4V4Z"
        fill="white"
      />
    </svg>
  );
};

export const Youtube = () => {
  return (
    <>
      <svg
        width="30"
        height="30"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M21.543 6.498C22 8.28 22 12 22 12C22 12 22 15.72 21.543 17.502C21.289 18.487 20.546 19.262 19.605 19.524C17.896 20 12 20 12 20C12 20 6.107 20 4.395 19.524C3.45 19.258 2.708 18.484 2.457 17.502C2 15.72 2 12 2 12C2 12 2 8.28 2.457 6.498C2.711 5.513 3.454 4.738 4.395 4.476C6.107 4 12 4 12 4C12 4 17.896 4 19.605 4.476C20.55 4.742 21.292 5.516 21.543 6.498V6.498ZM10 15.5L16 12L10 8.5V15.5Z"
          fill="white"
        />
      </svg>
    </>
  );
};

export const Instagram = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 256 256"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M160 128C160 134.329 158.123 140.516 154.607 145.778C151.091 151.041 146.093 155.142 140.246 157.564C134.399 159.986 127.965 160.62 121.757 159.385C115.55 158.15 109.848 155.103 105.373 150.627C100.897 146.152 97.8496 140.45 96.6149 134.243C95.3801 128.035 96.0138 121.601 98.4359 115.754C100.858 109.907 104.959 104.909 110.222 101.393C115.484 97.8768 121.671 96 128 96C136.479 96.0264 144.603 99.4063 150.598 105.402C156.594 111.397 159.974 119.521 160 128V128ZM228 84V172C228 186.852 222.1 201.096 211.598 211.598C201.096 222.1 186.852 228 172 228H84C69.1479 228 54.9041 222.1 44.402 211.598C33.9 201.096 28 186.852 28 172V84C28 69.1479 33.9 54.9041 44.402 44.402C54.9041 33.9 69.1479 28 84 28H172C186.852 28 201.096 33.9 211.598 44.402C222.1 54.9041 228 69.1479 228 84V84ZM176 128C176 118.506 173.185 109.226 167.911 101.333C162.636 93.4391 155.14 87.2868 146.369 83.6538C137.598 80.0208 127.947 79.0702 118.636 80.9223C109.325 82.7744 100.772 87.346 94.0589 94.0589C87.346 100.772 82.7744 109.325 80.9223 118.636C79.0702 127.947 80.0208 137.598 83.6538 146.369C87.2868 155.14 93.4391 162.636 101.333 167.911C109.226 173.185 118.506 176 128 176C140.73 176 152.939 170.943 161.941 161.941C170.943 152.939 176 140.73 176 128ZM192 76C192 73.6266 191.296 71.3066 189.978 69.3332C188.659 67.3598 186.785 65.8217 184.592 64.9134C182.399 64.0052 179.987 63.7676 177.659 64.2306C175.331 64.6936 173.193 65.8365 171.515 67.5147C169.836 69.1929 168.694 71.3311 168.231 73.6589C167.768 75.9867 168.005 78.3995 168.913 80.5922C169.822 82.7849 171.36 84.6591 173.333 85.9776C175.307 87.2962 177.627 88 180 88C183.183 88 186.235 86.7357 188.485 84.4853C190.736 82.2348 192 79.1826 192 76Z"
        fill="white"
      />
    </svg>
  );
};

export const EyeIcon = () => {
  return (
    <svg
      width="22"
      height="15"
      viewBox="0 0 22 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11 4.5C11.7956 4.5 12.5587 4.81607 13.1213 5.37868C13.6839 5.94129 14 6.70435 14 7.5C14 8.29565 13.6839 9.05871 13.1213 9.62132C12.5587 10.1839 11.7956 10.5 11 10.5C10.2044 10.5 9.44129 10.1839 8.87868 9.62132C8.31607 9.05871 8 8.29565 8 7.5C8 6.70435 8.31607 5.94129 8.87868 5.37868C9.44129 4.81607 10.2044 4.5 11 4.5ZM11 0C16 0 20.27 3.11 22 7.5C20.27 11.89 16 15 11 15C6 15 1.73 11.89 0 7.5C1.73 3.11 6 0 11 0ZM2.18 7.5C2.98825 9.15031 4.24331 10.5407 5.80248 11.5133C7.36165 12.4858 9.1624 13.0013 11 13.0013C12.8376 13.0013 14.6383 12.4858 16.1975 11.5133C17.7567 10.5407 19.0117 9.15031 19.82 7.5C19.0117 5.84969 17.7567 4.45925 16.1975 3.48675C14.6383 2.51424 12.8376 1.99868 11 1.99868C9.1624 1.99868 7.36165 2.51424 5.80248 3.48675C4.24331 4.45925 2.98825 5.84969 2.18 7.5Z"
        fill="#84298bbf"
      />
    </svg>
  );
};
export const DownloadIcon = () => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 11.575C7.86667 11.575 7.74167 11.5543 7.625 11.513C7.50834 11.4717 7.4 11.4007 7.3 11.3L3.7 7.7C3.51667 7.51667 3.425 7.28334 3.425 7C3.425 6.71667 3.51667 6.48334 3.7 6.3C3.88333 6.11667 4.121 6.021 4.413 6.013C4.705 6.005 4.94234 6.09234 5.125 6.275L7 8.15V1C7 0.71667 7.096 0.479004 7.288 0.287004C7.48 0.0950036 7.71734 -0.000663206 8 3.4602e-06C8.28334 3.4602e-06 8.521 0.0960036 8.713 0.288004C8.905 0.480004 9.00067 0.717337 9 1V8.15L10.875 6.275C11.0583 6.09167 11.296 6.004 11.588 6.012C11.88 6.02 12.1173 6.116 12.3 6.3C12.4833 6.48334 12.575 6.71667 12.575 7C12.575 7.28334 12.4833 7.51667 12.3 7.7L8.7 11.3C8.6 11.4 8.49167 11.471 8.375 11.513C8.25834 11.555 8.13334 11.5757 8 11.575ZM2 16C1.45 16 0.979002 15.804 0.587002 15.412C0.195002 15.02 -0.000664969 14.5493 1.69779e-06 14V12C1.69779e-06 11.7167 0.0960018 11.479 0.288002 11.287C0.480002 11.095 0.717335 10.9993 1 11C1.28333 11 1.521 11.096 1.713 11.288C1.905 11.48 2.00067 11.7173 2 12V14H14V12C14 11.7167 14.096 11.479 14.288 11.287C14.48 11.095 14.7173 10.9993 15 11C15.2833 11 15.521 11.096 15.713 11.288C15.905 11.48 16.0007 11.7173 16 12V14C16 14.55 15.804 15.021 15.412 15.413C15.02 15.805 14.5493 16.0007 14 16H2Z"
        fill="#006fc3bf"
      />
    </svg>
  );
};
